import Typography from '@mui/material/Typography';
import { Item, Section } from 'src/@types/Course';
import Iconify from 'src/components/Iconify';
import { Stack, Button } from '@mui/material';
import SectionsItemTable from '../section-item-table/SectionsItemTable';
import TextMaxLine from 'src/components/TextMaxLine';
import { useCourseSummery } from '../useCourseSummery';
import { Accordion, AccordionDetails, AccordionSummary } from '../styles';
type currentItemType = { item: Item; index: number };
export const SectionSummery = ({
  section,
  setCurrentSection,
  onDeleteSection,
  sectionIndex,
  setCurrentItem,
  setModalOpen,
  onDeleteItem,
  expanded,
  setExpanded,
  SetSectionModalOpen,
  onGoUpDown,
}: {
  section: Section;
  setCurrentSection: (section: Section, index: number) => void;
  onDeleteSection: VoidFunction;
  sectionIndex: number;
  setCurrentItem(item: currentItemType): void;
  setModalOpen(open: boolean): void;
  onDeleteItem(itemIndex: number, sectionIndex: number): void;
  expanded: false | string;
  setExpanded: React.Dispatch<React.SetStateAction<string | false>>;
  SetSectionModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onGoUpDown: (fromIndex: number, toIndex: number) => void;
}) => {
  const { handleChange, getMenuItem } = useCourseSummery(
    setCurrentSection,
    onDeleteSection,
    section,
    sectionIndex,
    setExpanded,
    SetSectionModalOpen
  );
  return (
    <Accordion
      expanded={expanded === `panel${sectionIndex}`}
      onChange={handleChange(`panel${sectionIndex}`)}
    >
      <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          sx={{ width: '100%' }}
          spacing={3}
          alignItems={'center'}
        >
          <Typography>{section.title}</Typography>
          {getMenuItem()}
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <>
          <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
            <TextMaxLine
              marginBottom={'20px'}
              marginTop={'20px'}
              fontSize={'22px'}
              sx={{ overflow: 'unset' }}
            >
              {'Section Items'}
            </TextMaxLine>
            <Button
              variant="contained"
              size="small"
              sx={{ height: '40px' }}
              onClick={() => {
                console.log('setCurrent', section);
                console.log('setCurrent', sectionIndex);
                setCurrentSection(section, sectionIndex);
                setModalOpen(true);
              }}
              startIcon={<Iconify icon={'eva:plus-fill'} />}
            >
              New Section Item
            </Button>
          </Stack>
          <SectionsItemTable
            onGoUpDown={onGoUpDown}
            onEdit={(item, index) => {
              setCurrentSection(section, sectionIndex);
              setCurrentItem({
                item: item,
                index: index,
              });
              setModalOpen(true);
            }}
            onDeleteItem={(index) => {
              setCurrentSection(section, sectionIndex);
              onDeleteItem(index, sectionIndex);
              setModalOpen(false);
            }}
            items={section?.items ?? []}
          />
        </>
      </AccordionDetails>
    </Accordion>
  );
};
